import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { 
  FiFacebook, 
  FiInstagram, 
  FiTwitter, 
  FiPhone, 
  FiMail, 
  FiMapPin 
} from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-black text-white pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="space-y-6"
          >
            <Link to="/" className="text-3xl font-playfair font-bold bg-gradient-to-r from-gold to-yellow-400 bg-clip-text text-transparent">
              Ms Bridal Wear
            </Link>
            <p className="text-lg font-montserrat text-gray-400 leading-relaxed">
              Luxury bridal fashion for your most special moments. 
              Exquisite craftsmanship meets timeless elegance.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-12 h-12 bg-white/10 hover:bg-white/20 rounded-2xl flex items-center justify-center transition-all">
                <FiInstagram className="w-6 h-6" />
              </a>
              <a href="#" className="w-12 h-12 bg-white/10 hover:bg-white/20 rounded-2xl flex items-center justify-center transition-all">
                <FiFacebook className="w-6 h-6" />
              </a>
              <a href="#" className="w-12 h-12 bg-white/10 hover:bg-white/20 rounded-2xl flex items-center justify-center transition-all">
                <FiTwitter className="w-6 h-6" />
              </a>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="space-y-4"
          >
            <h3 className="text-xl font-playfair font-semibold mb-6">Quick Links</h3>
            <div className="space-y-3">
              <Link to="/" className="block font-montserrat hover:text-gold transition-colors">Home</Link>
              <Link to="/shop" className="block font-montserrat hover:text-gold transition-colors">Shop</Link>
              <Link to="/shop?category=bridal-lehenga" className="block font-montserrat hover:text-gold transition-colors">Bridal Lehenga</Link>
              <Link to="/shop?category=party-wear" className="block font-montserrat hover:text-gold transition-colors">Party Wear</Link>
              <Link to="/cart" className="block font-montserrat hover:text-gold transition-colors">Cart</Link>
            </div>
          </motion.div>

          {/* Collections */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="space-y-4"
          >
            <h3 className="text-xl font-playfair font-semibold mb-6">Collections</h3>
            <div className="space-y-3">
              <Link to="/shop?category=bridal-lehenga" className="block font-montserrat hover:text-gold transition-colors">Bridal Lehenga</Link>
              <Link to="/shop?category=designer-sarees" className="block font-montserrat hover:text-gold transition-colors">Designer Sarees</Link>
              <Link to="/shop?category=wedding-gowns" className="block font-montserrat hover:text-gold transition-colors">Wedding Gowns</Link>
              <Link to="/shop?category=party-wear" className="block font-montserrat hover:text-gold transition-colors">Party Wear</Link>
              <Link to="/shop?category=reception-dresses" className="block font-montserrat hover:text-gold transition-colors">Reception Dresses</Link>
            </div>
          </motion.div>

          {/* Contact */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="space-y-6"
          >
            <h3 className="text-xl font-playfair font-semibold mb-6">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-4">
                <FiMapPin className="w-6 h-6 mt-1 text-gold flex-shrink-0" />
                <div>
                  <p className="font-montserrat">Bandra West, Mumbai</p>
                  <p className="font-montserrat">Maharashtra 400050</p>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <FiPhone className="w-6 h-6 text-gold" />
                <a href="tel:+918369560797" className="font-montserrat hover:text-gold">+91 8369560797</a>
              </div>
              <div className="flex items-center space-x-4">
                <FiMail className="w-6 h-6 text-gold" />
                <a href="mailto:msbridalwear@gmail.com" className="font-montserrat hover:text-gold">
                  msbridalwear@gmail.com
                </a>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-12 mt-16">
          <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-4 md:space-y-0">
            <p className="font-montserrat text-gray-400">
              © 2026 Ms Bridal Wear. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center md:justify-end gap-6">
              <Link to="/privacy" className="font-montserrat hover:text-gold transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="font-montserrat hover:text-gold transition-colors">Terms of Service</Link>
              <Link to="/returns" className="font-montserrat hover:text-gold transition-colors">Returns</Link>
              <Link to="/shipping" className="font-montserrat hover:text-gold transition-colors">Shipping</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;